// Create Audio instances for each sound
const clickSound = new Audio('/sounds/click.mp3');
const colorSelectSound = new Audio('/sounds/color-select.mp3');

// Configure sounds
clickSound.volume = 0.5;
colorSelectSound.volume = 0.4;

// Preload sounds
clickSound.load();
colorSelectSound.load();

export const playClickSound = () => {
  try {
    clickSound.currentTime = 0; // Reset the sound to start
    clickSound.play().catch(error => {
      console.error('Error playing click sound:', error);
    });
  } catch (error) {
    console.error('Error with click sound:', error);
  }
};

export const playErrorSound = () => {
  try {
    clickSound.currentTime = 0; // Reset the sound to start
    clickSound.play().catch(error => {
      console.error('Error playing click sound:', error);
    });
  } catch (error) {
    console.error('Error with click sound:', error);
  }
};

export const playColorSelectSound = () => {
  try {
    colorSelectSound.currentTime = 0;
    colorSelectSound.play().catch(error => {
      console.error('Error playing color select sound:', error);
    });
  } catch (error) {
    console.error('Error with color select sound:', error);
  }
}; 